/* globals jQuery, $ */

import UAParser from 'ua-parser-js';

;(function ($) {
  $.shopgate = $.shopgate || {};
  $.sgHelpers = $.sgHelpers || {};
  /**
   * This helper encapsulates the jQuery ajax function. All common ajax options can be used.
   * @param {object} [options] plugin options
   */

  $.shopgate.ajax = function (options) {

    var defaults = {
      url: '',
      async: true,
      cache: false,
      type: 'POST',
      locationReplace: false,
      addHistoryEntry: false,
      timeout: null,
      dataType: 'json',
      data: null,
      hideWaitingIndicator: true,
      previewSrc: 'sgapi:page_preview',
      beforeSend: function (jqXHR, settings) {
      },
      complete: function (jqXHR, textStatus) {
      },
      error: function (jqXHR, textStatus, errorThrown) {
      },
      success: function (data, textStatus, jqXHR) {
      }
    };

    options = options || {};
    options = $.extend({}, defaults, options);

    if (!options.url) {
      console.error('Error: no request url assigned');
      return false;
    }

    // prepare the ajax options
    var ajaxOptions = $.extend({}, options);

    ajaxOptions.beforeSend = function (jqXHR, settings) {
      options.beforeSend(jqXHR, settings);
    }

    ajaxOptions.complete = function (jqXHR, textStatus) {
      if (options.hideWaitingIndicator) {
        $(document).trigger('shopgateFramework.waitingIndicator.hide');
      }

      options.complete(jqXHR, textStatus);
    }

    ajaxOptions.error = function (jqXHR, textStatus, errorThrown) {
      options.error(jqXHR, textStatus, errorThrown);
    }

    ajaxOptions.success = function (data, textStatus, jqXHR) {
      // check if we've got an json object in the response
      if (options.dataType == 'json' && typeof data == 'object') {
        // the server requested a redirect
        if (typeof data.redirect == 'string') {
          var targetTab = typeof data.targetTab == 'string' && data.targetTab ? data.targetTab : null;

          if (ajaxOptions.addHistoryEntry == true) {
            openUrl({
              src: data.redirect,
              previewSrc: ajaxOptions.previewSrc,
              targetTab: targetTab
            });
          } else {
            openUrl({
              src: data.redirect,
              noHistory: true,
              previewSrc: ajaxOptions.previewSrc,
              targetTab: targetTab
            });
          }
        }

        // the server has sent a flash message. trigger the necessary event
        if (typeof data.systemMessage == 'object' && data.systemMessage) {
          if (data.systemMessage.systemMessageUpdate) {
            $(document).trigger('sgFramework.message.system', [data.systemMessage]);
          }
          // remove the message from the response
          delete data.systemMessage;
        } else {
          $(document).trigger('sgFramework.message.system');
        }
      }

      // call the original callback function
      options.success(data, textStatus, jqXHR);
    }

    // do the ajax request
    return $.ajax(ajaxOptions);
  };

  $.shopgate.ajaxContentUpdate = function (options) {
    var defaults = {
      url: '',
      targetSelector: '#content',
      data: null,
      beforeSend: function (jqXHR, settings) {
      },
      complete: function (jqXHR, textStatus) {
      },
      error: function (jqXHR, textStatus, errorThrown) {
      },
      success: function (data, textStatus, jqXHR) {
      }
    };

    options = options || {};
    options = $.extend({}, defaults, options);

    // prepare the ajax options
    var ajaxOptions = $.extend({}, options);

    ajaxOptions.beforeSend = function (jqXHR, settings) {
      if ($('.page-loading').length > 0) {
        $.shopgate.spinner('show');
      } else {
        $(options.targetSelector).animate({ opacity: '.4' });
        $('input, button, a', options.targetSelector).addClass('disabled').attr('disabled', true);
      }
      options.beforeSend(jqXHR, settings);
    };

    ajaxOptions.complete = function (jqXHR, textStatus) {
      if ($('.page-loading').length > 0) {
        $.shopgate.spinner('hide');
      } else {
        $(options.targetSelector).animate({ opacity: '1' });
        $('input, button, a', options.targetSelector).removeClass('disabled').removeAttr('disabled', true);
      }
      options.complete(jqXHR, textStatus);
    };

    ajaxOptions.error = function (jqXHR, textStatus, errorThrown) {
      options.error(jqXHR, textStatus, errorThrown);
    };

    ajaxOptions.success = function (data, textStatus, jqXHR) {
      if (data.html) {
        $(options.targetSelector).html(data.html);
        $(document).trigger('shopgateFramework.ui.contentUpdated');
      }
      options.success(data, textStatus, jqXHR);
    };

    $.shopgate.ajax(ajaxOptions);
  };

  /**
   * Takes a string and escapes some special characters.
   *
   * @param {string} str - The string that should be escaped.
   * @returns {string} - The escaped string.
   */
  $.shopgate.escapeRegExp = function (str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  };

  /**
   * Takes a string and inserts <strong> tags around matching sub-strings.
   *
   * @param {string} content - The text content to parse.
   * @param {string} match - The substring to find within content.
   * @returns {boolean | string} - The parsed content, false if no content given.
   */
  $.shopgate.boldify = function (content, match) {
    // The given content is not a string, forget it.
    if (typeof content !== 'string') {
      return false;
    }

    // The content is a blank string.
    if (content === '') {
      return content;
    }

    // Escape the special characters in the match substring.
    var escapedMatch = $.shopgate.escapeRegExp(match);

    // Perform the replace.
    var newContent = content.replace(new RegExp('(' + escapedMatch + ')', 'gi'), '<strong>$1</strong>');

    return newContent;
  };

  $.shopgate.formatNumber = function (number, decimals, dec_point, thousands_sep) {
    number = (number + '')
      .replace(/[^0-9+\-Ee.]/g, '');
    var n          = !isFinite(+number) ? 0 : +number,
        prec       = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep        = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec        = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s          = '',
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return '' + (Math.round(n * k) / k)
              .toFixed(prec);
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
      .split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
        .length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1)
        .join('0');
    }
    return s.join(dec);
  };

  /*
   * Natural Sort algorithm for Javascript - Version 0.6 - Released under MIT license
   * Author: Jim Palmer (based on chunking idea from Dave Koelle)
   * Contributors: Mike Grier (mgrier.com), Clint Priest, Kyle Adams, guillermo
   */
  $.sgHelpers.naturalSort = function (a, b) {
    var re  = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
        sre = /(^[ ]*|[ ]*$)/g,
        dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
        hre = /^0x[0-9a-f]+$/i,
        ore = /^0/,
        // convert all to strings and trim()
        x   = a.toString().replace(sre, '') || '',
        y   = b.toString().replace(sre, '') || '',
        // chunk/tokenize
        xN  = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
        yN  = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
        // numeric, hex or date detection
        xD  = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
        yD  = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
        oFxNcL,
        oFyNcL;
    // first try and sort Hex codes or Dates
    if (yD)
      if (xD < yD) return -1;
      else if (xD > yD) return 1;
    // natural sorting through split numeric strings and default strings
    for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return (isNaN(oFxNcL)) ? 1 : -1;
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
        oFxNcL += '';
        oFyNcL += '';
      }
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
    }
    return 0;
  };

  $.shopgate.naturalSort = $.sgHelpers.naturalSort;

  $.sgHelpers.sizeSort = function (a, b, fallback) {
    if (a == b) {
      return 0;
    }

    if (!fallback) {
      fallback = $.sgHelpers.naturalSort;
    }

    var appendNotFound = true; // append options not found in array

    var sortingArray = [
          "one", "einheit", "uni",
          "xxs",
          "xs", "x-small", "extra small", "xsmall",
          "xs/s", "xs-s", "xs - s",
          "s", "small",
          "s/m", "s-m", "s - m", "small-medium",
          "m", "medium", "regular",
          "m/l", "m-l", "m - l", "medium-large",
          "l", "large",
          "l/xl", "l-xl", "l - xl", "large-xlarge",
          "xl", "x-large", "extra large", "1x", "xlarge",
          "xl/xxl", "xl-xxl", "xl - xxl",
          "xxl", "xx-large", "2x", "xxlarge",
          "xxl/xxxl", "xxl-xxxl", "xxl - xxxl",
          "xxxl", "3x", "3xl", "3xlarge", "xxxlarge",
          "xxxl/xxxxl", "xxxl-xxxxl", "xxxl - xxxxl",
          "xxxxl", "4x",
          "xxxxl/xxxxxl", "xxxxl-xxxxxl", "xxxxl - xxxxxl",
          "xxxxxl", "5x",
          "ys", "ym", "yl", "yxl", "yxxl",
          "ys/8", "ym/10-12", "yl/14-16", "yxl/18-20",
          "youth-one-size", "t", "1t", "2t", "3t", "4t", "5t", "6t",
          "0-3mo", "3-6mo", "6-9mo", "12mo", "18mo", "24mo",
          "kids-4", "kids-5/6", "kids-7",
          "kids-4/small", "kids-5-6/medium", "kids-7/large",
          "womens-5", "womens-6", "womens-7", "womens-8", "womens-9", "womens-10", "womens-11", "womens-12",
          "size-6-1/8", "size-6-1/4", "size-6-3/8", "size-6-1/2", "size-6-5/8", "size-6-3/4", "size-6-7/8", "size-7", "size-7-1/8", "size-7-1/4", "size-7-3/8", "size-7-1/2", "size-7-5/8", "size-7-3/4", "size-7-7/8", "size-8"
        ],
        len          = sortingArray.length,
        aLowerCase   = a.toLowerCase(),
        bLowerCase   = b.toLowerCase(),
        positionOfA  = sortingArray.indexOf(aLowerCase),
        positionOfB  = sortingArray.indexOf(bLowerCase);

    // if not found exactly in array look for entry starting with it
    function indexOfStartingWith(needle) {
      for (var i = 0; i < len; i++) {
        if (needle.indexOf(sortingArray[i]) === 0) {
          return i;
        }
      }
      return -1;
    }

    if (positionOfA == -1) {
      positionOfA = indexOfStartingWith(aLowerCase);
    }
    if (positionOfB == -1) {
      positionOfB = indexOfStartingWith(bLowerCase);
    }

    if (positionOfA == -1 && positionOfB == -1) {
      return fallback(a, b);
    } else if (positionOfA == -1) {
      return appendNotFound ? 1 : -1;
    } else if (positionOfB == -1) {
      return appendNotFound ? -1 : 1;
    } else if (positionOfA == positionOfB) {
      return 0;
    } else {
      return (positionOfA < positionOfB) ? -1 : 1;
    }
  };

  $.sgHelpers.bin2hex = function (s) {
    // convert to utf-8
    s = unescape(encodeURIComponent(s));

    // origin: http://phpjs.org/functions/bin2hex/
    var i, l, o = '',
        n;
    s += '';
    for (i = 0, l = s.length; i < l; i++) {
      n = s.charCodeAt(i)
        .toString(16);
      o += n.length < 2 ? '0' + n : n;
    }
    return o;
  };

  $.sgHelpers.hex2bin = function (str) {
    var s = str;
    var ret = [];
    var i = 0;
    var l;
    s += '';
    for (l = s.length; i < l; i += 2) {
      var c = parseInt(s.substr(i, 1), 16);
      var k = parseInt(s.substr(i + 1, 1), 16);
      if (isNaN(c) || isNaN(k)) return false;
      ret.push((c << 4) | k);
    }

    return String.fromCharCode.apply(String, ret);
  };

  $.sgHelpers.getUrlQueryObject = function (url) {
    var queryParams = { params: {} }, temp = null, hash = '', path = '';
    // wenn keine url uebergeben wurde, wird die url der aktuellen seite verwendet
    if (!url) {
      url = sgWindow.location.href;
    }

    // hash sichern und aus url entfernen
    hash = url.substring(url.lastIndexOf('#') + 1, url.length);
    hash = hash != url ? hash : '';
    if (hash) {
      url = url.substr(0, url.lastIndexOf('#'));
    }
    url = url.replace('#', '');

    // query-string nach parameterbloecken splitten
    temp = url.toString().split('?');
    path = temp.shift();
    temp = temp.length > 0 ? temp.pop().split('&') : '';

    // parameterbloecke in objekt ablegen
    if ($.isArray(temp) && temp[0] != url) {
      $.each(temp, function (index, prop) {
        var item                      = prop.split('='),
            key = item.shift(), value = item.shift();

        if (key)
          queryParams['params'][key] = value ? value : '';
      });
    }

    // funktionen fuer datenzugriff definieren
    queryParams.getPath = function () {
      return path;
    };
    queryParams.setPath = function (value) {
      path = value;
    }
    queryParams.getHash = function () {
      return hash;
    };
    queryParams.setHash = function (value) {
      hash = value;
    };
    queryParams.getParam = function (key) {
      return queryParams['params'][key] ? queryParams['params'][key] : null;
    };
    queryParams.setParam = function (key, value) {
      queryParams['params'][key] = value ? value : '';
    };

    queryParams.toString = function (withPath) {
      var query = '';
      $.each(this['params'], function (key, value) {
        if (!value) {
          return;
        }
        query += key + '=' + value + '&';
      });

      if (query) {
        query = query.substr(0, query.lastIndexOf('&'));
      }
      if (hash) {
        query += '#' + hash;
      }
      if (withPath) {
        query = path + '?' + query;
      }
      return query;
    };

    return queryParams;
  };

  $.shopgate.urlParser = $.sgHelpers.getUrlQueryObject;

  $.sgHelpers.checkPluginPrerequisites = function (caller, pluginList) {
    if (typeof caller == 'object') {
      pluginList = caller;
      caller = '';
    }

    var execute = true;

    if ($.isArray(pluginList)) {
      $.each(pluginList, function (index, plugin) {
        if (typeof eval(plugin) != 'function') {
          console.warn('%s: %s not loaded', caller, plugin);
          execute = false;
        }
      });
    }
    return execute;
  };

  $.shopgate.checkPluginPrerequisites = $.sgHelpers.checkPluginPrerequisites;

  var elementForEntities = document.createElement('div');

  $.shopgate.decodeHTMLEntities = function (value) {
    try {
      if (value && typeof value === 'string') {
        // Escape HTML before decoding for HTML Entities
        value = escape(value).replace(/%26/g, '&').replace(/%23/g, '#').replace(/%3B/g, ';');

        elementForEntities.innerHTML = value;
        if (elementForEntities.innerText) {
          value = elementForEntities.innerText;
          elementForEntities.innerText = '';
        } else {
          // Firefox support
          value = elementForEntities.textContent;
          elementForEntities.textContent = '';
        }
      }

      return unescape(value);
    } catch (e) {
      return value;
    }
  };

  $.shopgate.encodeHTMLEntities = function (value) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };

    return String(value).replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  };

  var currentModal = null;

  $.shopgate.modal = function (options) {
    var defaults = {
      title: '',
      body: '',
      closeButtonOutsideModal: false,
      closeOnBackdropTap: true,
      timer: 0,
      fixedBodyHeight: false,
      closeExistingModals: false,
      afterHide: function () {
      },
      offsets: {
        top: 0,
        bottom: 0
      },
      buttons: {
        primaryButton: $.i18n._('modal_alert_button_ok').toUpperCase(),
        primaryButtonAction: null,
        secondaryButton: false,
        secondaryButtonAction: null,
        tertiaryButton: null,
        tertiaryButtonAction: null,
      }
    };

    options = options || {};
    options = $.extend(true, {}, defaults, options);

    if (options.closeExistingModals && currentModal && currentModal.length) {
      currentModal.remove();
      $('.modal-backdrop').remove();
      currentModal = null;
    }

    var modalWrapper    = $('<div>').addClass('modal default-modal fade').attr('aria-live', 'assertive'),
        modalDialog     = $('<div>').addClass('modal-dialog'),
        modalContent    = $('<div>').addClass('modal-content'),
        modalHeader     = $('<div>').addClass('modal-header'),
        modalBody       = $('<div>').addClass('modal-body'),
        modalFooter     = $('<div>').addClass('modal-footer'),
        closeCross      = $('<button>').addClass('close').attr({
          'type': 'button',
          'data-dismiss': 'modal',
          'aria-hidden': 'true'
        }).html('x'),
        closeButton     = $('<div>').attr({
          'type': 'button',
          'data-dismiss': 'modal'
        }).addClass('btn btn-default').text($.i18n._('modal_alert_button_ok')),
        primaryButton   = $('<a>').addClass('btn btn-block btn-primary primary').attr({ 'type': 'button'}),
        secondaryButton = $('<a>').addClass('btn btn-secondary secondary').attr({ 'type': 'button' }),
        tertiaryButton = $('<a>').addClass('btn btn-secondary tertiary').attr({ 'type': 'button' }),
        modalOptions    = {};

    if (!options.closeOnBackdropTap) {
      modalOptions.backdrop = 'static';
    }

    if (options.closeButtonOutsideModal) {
      modalWrapper.addClass('close-outside-modal');
    }

    if (options.title) {
      var modalTitle = $('<h5>').addClass('modal-title').html(options.title);

      modalHeader.append(closeCross, modalTitle);
      modalContent.removeClass('modal-without-title');
    } else {
      modalContent.append(closeCross);
      modalContent.addClass('modal-without-title');
      modalHeader.hide();
    }

    if (options.body) {
      modalBody.html(options.body);
    }

    _setupPrimaryButton(options.buttons.primaryButton, options.buttons.primaryButtonAction);
    _setupSecondaryButton(options.buttons.secondaryButton, options.buttons.secondaryButtonAction);
    _setupTertiaryButton(options.buttons.tertiaryButton, options.buttons.tertiaryButtonAction);
    modalFooter.append([closeButton, primaryButton, secondaryButton, tertiaryButton]);

    closeButton.hide(); // previously modalFooter was hidden
    closeCross.hide(); // previously closeCross was not hidden

    modalWrapper.append(modalDialog.append(modalContent.append(modalHeader, modalBody, modalFooter)));

    $('body').prepend(modalWrapper);

    var modalMarginTop = parseInt(modalDialog.css('margin-top'));

    if (options.offsets.top) {
      modalMarginTop = modalMarginTop + options.offsets.top;
    }

    modalDialog.css({ 'margin-top': modalMarginTop });

    modalWrapper.modal(modalOptions).bind('shown.bs.modal', function () {
      $('body').addClass('modal-open');
      if (options.fixedBodyHeight) {
        modalBody.css({
          'overflow-y': 'scroll',
          'max-height': _calcModalBodyHeight(),
          'width': '100%'
        });
        $(window).resize(function () {
          modalBody.css({ 'max-height': _calcModalBodyHeight() });
        });
      }

      if (options.timer) {
        window.setTimeout(function () {
          modalWrapper.modal('hide');
        }, options.timer);
      }
    }).bind('hidden.bs.modal', function () {
      $('body').removeClass('modal-open');
      $(this).remove();
      options.afterHide();
    });

    currentModal = modalWrapper;

    return modalWrapper;

    function _calcModalBodyHeight() {
      return window.innerHeight - modalHeader.height() - modalFooter.height() - modalMarginTop - options.offsets.bottom - 10;
    }

    function _setupPrimaryButton(buttonLabel, buttonAction) {
      if (buttonLabel) {
        primaryButton.removeClass('hidden').html(buttonLabel);
      } else {
        primaryButton.addClass('hidden');
      }

      if (buttonAction && typeof buttonAction == 'string') {
        if (buttonAction.indexOf('SGAction') == -1) { // #shame
          primaryButton.attr('href', buttonAction);
        } else {
          primaryButton.unbind('click').bind('click', function () {
            eval(buttonAction); // #shame
          });
        }
      } else if (buttonAction && typeof buttonAction == 'function') {
        primaryButton.unbind('click').bind('click', buttonAction);
      } else {
        primaryButton.attr({ 'data-dismiss': 'modal' });
      }
    }

    function _setupSecondaryButton(buttonLabel, buttonAction) {

      if (buttonLabel) {
        secondaryButton.removeClass('hidden').html(buttonLabel);
      } else {
        secondaryButton.addClass('hidden');
      }

      if (buttonAction && typeof buttonAction == 'string') {
        if (buttonAction.indexOf('SGAction') == -1) { // #shame
          secondaryButton.attr('href', buttonAction);
        } else {
          secondaryButton.unbind('click').bind('click', function () {
            eval(buttonAction); // #shame
          });
        }

      } else if (buttonAction && typeof buttonAction == 'function') {
        secondaryButton.unbind('click').bind('click', buttonAction);
      } else {
        secondaryButton.attr({ 'data-dismiss': 'modal' });
      }
    }

    function _setupTertiaryButton(buttonLabel, buttonAction) {

      if (buttonLabel) {
        tertiaryButton.removeClass('hidden').html(buttonLabel);
      } else {
        tertiaryButton.addClass('hidden');
      }

      if (buttonAction && typeof buttonAction == 'string') {
        if (buttonAction.indexOf('SGAction') == -1) { // #shame
          tertiaryButton.attr('href', buttonAction);
        } else {
          tertiaryButton.unbind('click').bind('click', function () {
            eval(buttonAction); // #shame
          });
        }

      } else if (buttonAction && typeof buttonAction == 'function') {
        tertiaryButton.unbind('click').bind('click', buttonAction);
      } else {
        tertiaryButton.attr({ 'data-dismiss': 'modal' });
      }
    }
  };

  /**
   *
   * @param action ('show', 'hide') - executes show or hide method
   * @returns Spinner singleton object
   */
  $.shopgate.spinner = function (action, delay) {
    /**
     * Spinner class.
     *
     * @constructor
     */

    var Spinner = function () {
      var _this           = this,
          currentState    = null,// null - not established, true - visible, false - not visible
          possibleActions = ['show', 'hide', 'clear'],// actions possible to execute providing an 'action' argument
          events          = {
            SPINNER_SHOWING: 'spinner_showing',
            SPINNER_SHOWN: 'spinner_shown',
            SPINNER_HIDING: 'spinner_hiding',
            SPINNER_HIDDEN: 'spinner_hidden'
          },
          eventsNames     = [],
          $spinnerEl      = $('.page-loading'),
          defaultDelay    = 1300, // default timeout for displaying spinner if not overwritten by custom timing
          spinnerTimeout; // empty var for timeout usage

      function _init() {
        $.each(events, function (key, value) {
          eventsNames.push(value);
        });
      }

      /**
       * Shows loading spinner and triggers events on
       * singletonIntance.
       *
       * @returns {boolean}
       */
      _this.show = function (delay) {
        clearTimeout(spinnerTimeout);
        delay = (typeof delay !== 'undefined') ? delay : defaultDelay;

        if ($spinnerEl.hasClass('loader-hidden')) {
          trigger(events.SPINNER_SHOWING);
          // set timeout for loading spinner to only show up if loading takes longer than ms mentioned below | 1300ms
          spinnerTimeout = setTimeout(function () {
            $spinnerEl.removeClass('loader-hidden').fadeIn(function () {
              trigger(events.SPINNER_SHOWN);
            });

            currentState = true;

            return true;
          }, delay);
        }

        return false;
      };

      /**
       * Hides loading spinner and triggers events on
       * singletonInstance.
       *
       * @returns {boolean}
       */
      _this.hide = function () {
        // clear timeout on hiding spinner
        clearTimeout(spinnerTimeout);
        trigger(events.SPINNER_HIDING);

        if (!$spinnerEl.hasClass('loader-hidden')) {
          // fadeOut with 100ms to not block longer than necessary but still animate smoothly
          $spinnerEl.fadeOut(100, function () {
            $spinnerEl.addClass('loader-hidden');
            trigger(events.SPINNER_HIDDEN);
          });
          currentState = false;

          return true;
        }

        $spinnerEl.addClass('loader-hidden');

        return false;
      };

      /**
       * Clears DOM element of any given style.
       * Also, hides the element.
       */
      _this.clear = function () {
        trigger(events.SPINNER_HIDING);

        $spinnerEl
          .attr('style', '')
          .addClass('loader-hidden');

        currentState = false;

        trigger(events.SPINNER_HIDDEN);

        return true;
      };

      /**
       * Validates provided action name.
       *
       * @param name
       * @returns {boolean}
       */
      _this.validateAction = function (name) {
        if (possibleActions.indexOf(name) === -1) {
          console.error('Unsupported action. Supported actions: show | hide');
          return false;
        }

        return true;
      };

      /**
       * Checks if loading spinner is visible.
       * @returns {boolean}
       */
      _this.isShown = function () {
        if (!currentState) {
          return false;
        }

        return true;
      };

      /**
       * Returns possible events.
       * @returns {{SPINNER_SHOWING: string, SPINNER_SHOWN: string, SPINNER_HIDING: string, SPINNER_HIDDEN: string}}
       */
      _this.getEvents = function () {

        return events;
      };

      /**
       * Function triggers event on _this object.
       *
       * @param eventName
       * @returns {boolean}
       */
      function trigger(eventName) {
        if (eventsNames.indexOf(eventName) === -1) {
          console.error('Unsupported event. Check getEvents() method.');

          return false;
        }

        $(_this).trigger(eventName);

        return true;
      }

      _this.on = function (eventName, cb) {
        $(_this).on(eventName, cb);
        return _this;
      };

      _this.off = function (eventName) {
        $(_this).off(eventName);
        return _this;
      };

      _init();
    };

    if (!this.singletonInstance) {
      this.singletonInstance = new Spinner();
    }

    var _instance = this.singletonInstance;

    if (typeof action !== 'undefined') {
      if (!_instance.validateAction(action)) {
        console.error('Unsupported action.');
        return false;
      } else {
        _instance[action](delay);
      }
    }

    return _instance;
  };

  $.shopgate.spinner.prototype.singletonInstance = null;

  $.shopgate.objectLengthSafe = function (obj) {
    if (typeof obj !== 'object') {
      return -1;
    }
    if (typeof Object === 'function' && typeof Object.keys === 'function') {
      return Object.keys(obj).length;
    }

    var length = 0;

    for (var key in obj) {
      length++;
    }

    return length;


  };

  /**
   * Prepares params for Swiper which should be dynamic. Then creates Swiper instance and
   * passes it to a callback (if given)
   *
   * @param {Swiper} Swiper - Swiper function
   * @param {jQuery} $elements - jQuery array with element(s)
   * @param {object} params - params which will be passed to Swiper (you can skip loopedSlides)
   * @param {function} cb - optional, callback function
   */
  $.shopgate.sanitizeAndInitSwiper = function (Swiper, $elements, params, cb) {
    if (typeof Swiper !== 'function') {
      console.warn('Given Swiper is not a function. Aborting swiper creation.');

      return;
    }

    if (!$elements.jquery) {
      console.warn('Given $elements is not jQuery object. Aborting swiper creation');

      return;
    }

    $elements.each(function () {
      const $this = $(this);
      const itemParams = $.extend({}, params);

      if (itemParams.loop) {
        const wrapperSize = $this.width();
        const slideSize = $this.find('.swiper-slide').first().width();
        const estimatedSlidesPerView = Math.ceil(wrapperSize / slideSize);
        const minimumSlidersLooped = estimatedSlidesPerView * 2;
        const sliderCount = $this.find('.swiper-slide').length;
        const loopedSlides = sliderCount > minimumSlidersLooped ? sliderCount : minimumSlidersLooped;

        itemParams.loopedSlides = loopedSlides;
        itemParams.forceLoopedSlides = true;
      }

      const swiperInstance = new Swiper(this, itemParams);

      if (typeof cb === 'function') {
        cb(swiperInstance);
      }
    });

    $elements.find('img').unveil();
  };

  /**
   * Ensure equal heights
   */
  $.fn.responsiveEqualHeightGrid = function (action, options) {

    var _this = this;

    $(document).bind('shopgateFramework.ui.productListUpdated', function (e, callback) {

      if (typeof callback != 'function') {
        callback = function () {
        };
      }

      update();
      callback();
    });

    _this.bind('layoutChanged', function () {
      update();
    });

    var defaults = {
      children: [],
      itemSelector: '.single-product'
    };

    options = options || {};
    options = $.extend({}, defaults, options);

    switch (action) {
      case 'update':
        update();
        break;
      default:
        init();
    }

    function setHeightToMax(elements) {
      elements.css('height', 'auto');
      if (elements.length > 1) {
        var heights = $.map(elements, function (e) {
          return $(e).height()
        });
        var maxHeight = Math.max.apply(null, heights);
        elements.height(maxHeight);
      }
    }

    function update() {

      var cols   = 0,
          offset = 0;

      var allItems = _this.find(options.itemSelector);
      allItems.each(function (i, elem) {
        var elem_offset = $(elem).offset().top;
        if (offset == 0 || elem_offset == offset) {
          cols++;
          offset = elem_offset;
        } else {
          return false;
        }
      });

      var elements = allItems.slice(0);
      while (elements.length) {
        var row = $(elements.splice(0, cols));
        if (options.children && options.children.length) {
          options.children.forEach(function (child) {
            setHeightToMax(row.find(child));
          });
        } else {
          setHeightToMax(row);
        }
      }
    };

    function init() {
      $(window).bind('resize load', update);
      update();
    }

    return this;
  };

  /**
   * Class for the $.fn.supportClearForInput plugin.
   * @param el
   * @returns {}
   */
  var inputWithClear = function (el) {
    var that = this;
    var EVENT_MARKUP_READY = 'supportClearButtonReady';
    var parent, input, button;

    that.turnOn = function () {
      input.addClass('not-empty');
    };

    that.turnOff = function () {
      input.removeClass('not-empty');
    };

    that.clearInput = function () {
      input.prop('value', '');
      this.turnOff();
      input.trigger('focus');
    };

    var _getClearButtonTemplate = function () {
      var html =
            '<span class="clear-input">' +
            '<i class="sg sg-clear"></i>' +
            '</span>';
      return $(html);
    };

    var _createMarkup = function () {
      var parentEl = $('<div class="supports-clear-button">');
      input.wrap(parentEl);
      parent = input.parent('.supports-clear-button');
      button = _getClearButtonTemplate();
      button.appendTo(parent);
      input.trigger(EVENT_MARKUP_READY);
    };

    var _onInputChangeAction = function () {
      if (input.prop('value').length > 0) {
        that.turnOn();
      }
      else {
        that.turnOff();
      }
    };

    var _bindEvents = function () {
      input.on(EVENT_MARKUP_READY, function () {
        input.on('input', function () {
          _onInputChangeAction();
        });
        input.on('focus', function () {
          _onInputChangeAction();
        });
        input.on('blur', function () {
          that.turnOff();
        });
        button.on('click touch', function () {
          that.clearInput();
        });
      });
    };

    var _construct = function (el) {
      if (typeof el.jquery === 'undefined') {
        input = $(el);
      }
      else {
        input = el;
      }

      _bindEvents();
      _createMarkup();

      return that;
    };

    return _construct(el);

  };

  /**
   * Class adds support for clearing button to input.
   * Usage:
   * init: $('inputSelector').supportClearForInput();
   * any public method: $('inputSelector').supportClearForInput('nameOfPublicMethod');
   *
   * Keep in mind it also changes the markups (wrap the input with div and add next to
   * it a <span> element.
   *
   * To use it, you need to implement CSS for this plugin, which you can find at:
   * app/webroot/scss/hybrid/ios8/_forms.scss - .supports-clear-button...
   *
   * @param method
   */
  $.fn.supportClearForInput = function (method) {
    var methods = {
      init: function ($el) {
        $el.each(function (index, item) {
          if (!('clearButton' in item)) {
            item.clearButton = new inputWithClear(this);
          }
        });
      },
      execute: function ($el, method) {
        $el.each(function (index, item) {
          item.clearButton[method]();
        });
      }
    };
    if (typeof method === 'undefined') {
      methods.init(this);
    }
    else {
      methods.execute(this, method);
    }
  };


  /**
   * adjusts the font size according to the height of the outer element so that the text fits into the boundardies of the element.
   */
  $.fn.fontSizeFitHeight = function (options) {
    var defaults = {
      fontSteps: 2
    };

    options = options || {};
    options = $.extend({}, defaults, options);

    return this.each(function () {
      adjustHeights($(this));
    });

    function adjustHeights($elem) {
      if ($elem.outerHeight() > $elem.parent().outerHeight() || $elem.outerWidth() > $elem.parent().outerWidth()) {
        $elem.css({
          'font-size': (parseInt($elem.css('font-size')) - options.fontSteps) + 'px',
          'line-height': (parseInt($elem.css('font-size'))) + 'px'
        });
        adjustHeights($elem);
      }
    }


  }

  /**
   * Provides history.pushState functionality
   * despite of browser support.
   *
   * @returns {Function}
   */
  var _historyChangeInstance = null;
  $.sgHelpers.historyChange = function () {

    var EVENTS       = {
          SHOPGATE_HISTORY_PUSH_STATE: 'shopgate.history.push_state',
          SHOPGATE_HISTORY_REPLACE_STATE: 'shopgate.history.replace_state',
          SHOPGATE_HISTORY_URL_CHANGED: 'shopgate.history.url_changed'
        },
        _eventsNames = [
          EVENTS.SHOPGATE_HISTORY_PUSH_STATE,
          EVENTS.SHOPGATE_HISTORY_REPLACE_STATE,
          EVENTS.SHOPGATE_HISTORY_URL_CHANGED
        ],
        historyProto = function () {
        };
    /**
     * Constans getter.
     *
     * @returns {{SHOPGATE_HISTORY_PUSH_STATE: string, SHOPGATE_HISTORY_REPLACE_STATE: string, SHOPGATE_HISTORY_URL_CHANGED: string}}
     */
    historyProto.prototype.getEvents = function () {

      return EVENTS;
    };

    /**
     * Made for legacy browsers.
     * When new slug is pushed, hashHistory
     * changes it to hash.
     *
     * We still need the original for pushing
     * new url to GA tracker.
     *
     * @type {null}
     */
    var currentSlug = null;

    historyProto.prototype.getCurrentSlug = function () {
      if (currentSlug) {
        return currentSlug;
      } else {
        return this.sanitizePathname(location.pathname);
      }
    };

    historyProto.prototype.setCurrentSlug = function (slug) {
      currentSlug = this.sanitizePathname(slug);
      return currentSlug;
    };

    /**
     * Triggers event on the object.
     * Can be listened from the outside.
     *
     * @param eventName
     * @returns {null}
     */
    historyProto.prototype.triggerEvent = function (eventName) {
      if (_eventsNames.indexOf(eventName) === -1) {
        console.warn('Event not registered');
        return null;
      }

      $(this).trigger(eventName);
    };

    historyProto.prototype.sanitizePathname = function (pathname) {
      var pathWithoutDev = pathname.replace('/php/shopgate', '');

      return pathWithoutDev;
    };

    /**
     * Native (history.[func]) version of
     * historyChange object.
     * Is initiated  if browser supports history
     * manipulations.
     *
     */
    var nativeHistory = function () {
      var _this    = this,
          hashMode = false;

      /**
       * Public function to check if historyChange
       * uses hashes or pathnames.
       *
       * @returns {boolean}
       */
      this.getHashMode = function () {
        return hashMode;
      };

      this.pushState = function (data, title, slug) {
        history.pushState(data, title, slug);
        _this.setCurrentSlug(slug);
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_PUSH_STATE);
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_URL_CHANGED);
      };

      this.replaceState = function (data, title, slug) {
        history.replaceState(data, title, slug);
        _this.setCurrentSlug(slug);
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_REPLACE_STATE);
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_URL_CHANGED);
      };

      this.bindListener = function (callback) {
        if (typeof callback !== 'function') {
          console.warn('You must provide callback to bindListener');
        }

        window.addEventListener('popstate', function (e) {
          if (typeof e.state !== 'undefined') {
            _this.setCurrentSlug(location.pathname);
            _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_URL_CHANGED);
            callback(e.state);
          }
        });
      };

    };

    /**
     * Legacy fallback. Using url hash changes.
     */
    var hashHistory = function () {
      var _this    = this,
          hashMode = true;

      var storageScope = 'shopgateHistoryHelper';

      /**
       * Public function to check if historyChange
       * uses hashes or pathnames.
       *
       * @returns {boolean}
       */
      this.getHashMode = function () {
        return hashMode;
      };

      this.pushState = function (data, title, slug, internal) {
        _updateCurrentSlug(slug);
        window.location.hash = '#' + slug;
        $.sgHelpers.localStorage.setItem(slug, data, storageScope);

        if (typeof internal === 'undefined' || !internal) {
          _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_PUSH_STATE);
        }
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_URL_CHANGED);
      };

      this.replaceState = function (data, title, slug) {
        _updateCurrentSlug(slug);
        var currentState = window.location.hash.replace('#', '');

        if (currentState.length) {
          $.sgHelpers.localStorage.removeItem(currentState, storageScope);
        }
        _this.pushState(data, title, slug);
        _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_REPLACE_STATE);
      };

      this.bindListener = function (callback) {
        window.addEventListener('hashchange', function () {
          var data;
          if (typeof location.hash === 'string' && location.hash.length > 1) {
            var name = location.hash.replace('#', '');
            data = $.sgHelpers.localStorage.getItem(name, storageScope);
            _updateCurrentSlug(name);
          } else {
            data = {
              name: 'default'
            };
            _updateCurrentSlug('');
          }

          _this.triggerEvent(_this.getEvents().SHOPGATE_HISTORY_URL_CHANGED);
          callback(data);
        });
      };

      /**
       * Updates currentSlug local variable.
       * @param slug
       * @returns {*}
       */
      function _updateCurrentSlug(slug) {
        if (location.pathname[location.pathname.length - 1] != '/') {
          slug = '/' + slug;
        }

        return _this.setCurrentSlug(slug);
      }
    };

    /**
     * Singleton. We don't need multiple instances of this.
     *
     * @type {null}
     */

    function _getInstance() {
      if (!_historyChangeInstance) {
        if (Modernizr.history) {
          nativeHistory.prototype = new historyProto();
          _historyChangeInstance = new nativeHistory();
        } else {
          hashHistory.prototype = new historyProto();
          _historyChangeInstance = new hashHistory();
        }
      }

      return _historyChangeInstance;
    }

    return _getInstance();
  };

  /**
   * HistoryToggler toggles containers and maintain
   * related browser history behaviour.
   *
   * If history.pushState is not available, script
   * falls back to location.hash
   *
   * Usage:
   * var config = {
	 * 		stateOne: '[jQuery selector]',
	 * 		stateTwo: '[jQuery selector]'
	 * };
   * var states = new $.fn.shopgateHistoryToggler(config);
   *
   * $('button').on('click', function(){
	 *  	//this would hide every containers beside stateOne's and register browser history event
	 * 		states.pushState('stateOne', '[title - most browsers ignores this]');
	 * });
   *
   * $('button2').on('click', function(){
	 * 		// this would additionally replace content of stateTwo container with provided Url
	 * 		states.pushState('stateTwo', '[title - most browsers ignores this]', 'http://shopgate.com');
	 * });
   *
   *
   * @param config
   * @returns {boolean}
   */
  $.fn.shopgateHistoryToggler = function (config) {

    var that = this;

    // history state class
    var states;
    // private variables
    var containers = {};
    var registeredNames = [];

    if (typeof config !== 'object') {
      console.warn('You must provide configuration to make history toggler works');
      return false;
    }

    /**
     * Events ids.
     * For listen, use this.addListener()
     *
     * @type {{HISTORY_CHANGE: string, DOM_STATE_CHANGE: string}}
     */
    this.EventId = {
      HISTORY_CHANGE: 'sgHistoryTogglerHistoryChange',
      DOM_STATE_CHANGE: 'sgHistoryTogglerDOMChange'
    };

    this.getRegisteredNames = function () {
      return registeredNames;
    };

    /**
     * Registers new element. Since it's public function
     * can be used to extend existing instance of the class.
     *
     * @param name - stateName
     * @param selector - jQuery selector
     *
     * @returns {boolean}
     */
    this.addElement = function (name, selector) {
      if (typeof containers[name] !== 'undefined') {
        console.warn('Element already registered');
        return false;
      }
      containers[name] = $(selector);
      this.getRegisteredNames().push(name);

      return true;
    };

    /**
     * Hides all registered containers
     * despite container related to current browser state.
     *
     * @param inputData
     */
    this.toggleState = function (inputData) {
      var data = {
        name: 'default',
        title: null,
        contentUrl: null
      };
      $.extend(data, inputData);
      if (data.name !== 'default' && that.getRegisteredNames().indexOf(data.name) === -1) {
        return false;
      }
      $.each(containers, function (key, el) {
        if (key === data.name) {
          $(el).removeClass('hidden');
        } else {
          $(el).addClass('hidden');
        }
      });
      if (data.contentUrl) {
        var ajaxOpts = {
          url: data.contentUrl,
          targetSelector: containers[data.name].selector
        };
        $.shopgate.ajaxContentUpdate(ajaxOpts);
      }
      $(window).scrollTop(0);

      _triggerEvent(that.EventId.DOM_STATE_CHANGE, data);
    };

    /**
     * Creates new browser history event and toggles
     * browser state.
     *
     * @param name - stateName
     * @param title - title (ignored by most browsers)
     * @param contentUrl - URL for resources that should replace state's content (optional)
     */
    this.pushState = function (name, title, contentUrl) {
      if (typeof title === 'undefined' || !title) {
        title = document.title;
      }
      var data = {
        name: name,
        title: title,
        contentUrl: contentUrl
      };
      that.toggleState(data);
      var pathname = _preparePathName(data.name);

      states.pushState(data, title, pathname);
      _triggerEvent(that.EventId.HISTORY_CHANGE, data);
    };

    this.replaceState = function (name, title, contentUrl) {
      if (typeof title === 'undefined' || !title) {
        title = document.title;
      }
      var data = {
        name: name,
        title: title,
        contentUrl: contentUrl
      };
      that.toggleState(data);
      var pathname = _preparePathName(data.name);

      states.replaceState(data, title, pathname);
      _triggerEvent(that.EventId.HISTORY_CHANGE, data);
    };

    /**
     * .addListener(EventId, function(event, data);
     * EventId (string): EventId constants (eg. historyChange.EventId.HISTORY_CHANGE
     * event (object): jQuery event
     * data (object): {name, title, contentUrl}
     *
     * This function adds event listener for changes
     * this script makes.
     *
     * historyToggler triggers an event everytime
     * DOM or browser history is changed by the
     * script.
     *
     * For possible events, check EventId variable.
     *
     *
     * @param eventName
     * @param callback
     * @returns {boolean}
     */
    this.addListener = function (eventName, callback) {
      if (typeof callback !== 'function') {
        console.warn('Callback for must be function.');
        return false;
      }

      $(document).on(eventName, function (event, data) {
        callback(event, data);
      });

    };

    function _triggerEvent(eventName, data) {
      $(document).trigger(eventName, [data]);
    }

    function _getPathnameSlugs() {
      var currentPath = location.pathname;
      var pop;
      if (currentPath.charAt(location.pathname.length - 1) === '/') {
        pop = true;
      } else {
        pop = false;
      }
      var pathBlocks = currentPath.split('/');
      if (pop) {
        pathBlocks.pop(pathBlocks.length - 1);
      }

      return pathBlocks;

    }

    function _lastPathnameSlugIsState() {
      var pathBlocks = _getPathnameSlugs();
      var lastSlug = pathBlocks[pathBlocks.length - 1];

      return (that.getRegisteredNames().indexOf(lastSlug) > -1);
    }

    function _preparePathName(name) {
      if (typeof name === 'undefined') {
        name = '';
      }
      var pathname;

      if (!states.getHashMode()) {
        var pathSlugs = _getPathnameSlugs();
        if (_lastPathnameSlugIsState()) {
          pathSlugs.pop(pathSlugs.length - 1);
        }
        if (typeof name !== 'undefined' && name) {
          pathSlugs.push(name);
        }

        pathname = pathSlugs.join('/');
      } else {
        pathname = name;
      }

      return pathname;
    }

    function _construct() {
      states = new $.sgHelpers.historyChange();
      states.bindListener(that.toggleState);
      $.each(config, function (name, selector) {
        that.addElement(name, selector);
      });
    }

    _construct();
  };

  /**
   * Scrolls UI to jQuery selector's position.
   * If callback is given, will be called after
   * the animation is done.
   *
   * @param selector
   * @param options
   * @returns {boolean}
   */
  $.shopgate.scrollTo = function (selector, options) {
    var $element,
        defaults = {
          callback: null
        };

    options = $.extend({}, defaults, options);

    $element = $(selector);

    if (!$element.length) {
      return false;
    }

    $('html, body').scrollTo($element, {
      speed: 300,
      offset: 50,
      callback: options.callback
    });

    return true;
  };

  /**
   * Scrolls UI to jQuery selector's position.
   * If callback is given, will be called after
   * the animation is done.
   *
   * @param selector
   * @param options
   * @returns {jQuery}
   */
  $.fn.scrollTo = function (elem, options) {

    var defaults = {
      speed: 300,
      callback: null,
      offset: 50
    };

    options = $.extend({}, defaults, options);

    $(this)
      .animate({
        scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - (options.offset)
      }, options.speed)
      .promise()
      .done(options.callback);

    return this;
  };

  // Check if jQuery document is available (not the case on Apple TV)
  if ($(document)) {
    $(document).bind('shopgateFramework.waitingIndicator.show', function () {
      if ($('.page-loading').length > 0) {
        $.shopgate.spinner('show');
      }
    }).bind('shopgateFramework.waitingIndicator.hide', function () {
      if ($('.page-loading').length > 0) {
        $.shopgate.spinner('hide');
      }
    }).bind('shopgateFramework.ui.paymentButtonsUpdated', function () {
      var $containerWrapper       = $('.js-payment-button-container-wrapper'),
          $containerCaption       = $containerWrapper.find('.js-payment-button-caption'),
          $containers             = $containerWrapper.find('.js-payment-button-container'),
          hiddenContainersCounter = 0;

      $containers.each(function () {
        if ($(this).is(':hidden')) {
          hiddenContainersCounter++;
        }
      });

      $containerCaption.toggle($containers.length != hiddenContainersCounter);
    });
  }

  /**
   * Checks if two objects are equal (recursive)
   *
   * Important! It checks primitives only! No Date,
   * RegEx, Function, etc. comparison at the moment!
   *
   * @param {Object} x
   * @param {Object} y
   * @returns {boolean}
   */
  $.shopgate.areObjectsEqual = function (x, y) {
    return (x && y && typeof x === 'object' && typeof y === 'object') ?
    (Object.keys(x).length === Object.keys(y).length) &&
    Object.keys(x).reduce(function (isEqual, key) {
      return isEqual && $.shopgate.areObjectsEqual(x[key], y[key]);
    }, true) : (x === y);
  }

  /**
   * Simple stars plugin for adding reviews
   * Replacement of jQuery UI Stars
   *
   * @param options
   */
  $.fn.stars = function (options) {
    $(this).each(function () {

      var defaults = {
        starClass: 'ui-stars-star',
        starOnClass: 'ui-stars-star-on',
        starHoverClass: 'ui-stars-star-hover'
      };

      options = options || {};
      options = $.extend({}, defaults, options);

      var $container = $(this);
      var $originalInputs = $container.children('input');

      // Collect data
      var fieldName = $originalInputs.first().attr('name');
      var possibleValues = $originalInputs.map(function () {
        return $(this).val();
      }).get();
      var value = $originalInputs.filter(':checked').val();
      var selectedIndex = possibleValues.indexOf(value);

      // Remove original inputs
      $originalInputs.remove();

      // ARIA
      $container.attr('role', 'form');
      // Create stars
      var stars = [];
      $.each(possibleValues, function (index, possibleValue) {
        var $star = $('<div>', { class: options.starClass });
        $star.toggleClass(options.starOnClass, index <= selectedIndex);
        $star.append($('<a>', {
          innerText: possibleValue,
          role: 'button',
          'role': 'button',
          'aria-label': Math.round(possibleValue / 2),
        }));
        $star.find('a').append(`<span class="sr-only">${Math.round(possibleValue / 2)}</span>`);
        $container.append($star);
        stars.push($star);

        $star.hover(hoverStar.bind(this, index), hoverEnd);

        $star.click(selectIndex.bind(this, index));
      });

      // Create input
      var $input = $('<input>', {
        type: 'hidden',
        name: fieldName,
        value: value
      });
      $container.append($input);

      function hoverStar(hoveredIndex) {
        $.each(stars, function (index, $star) {
          $star.removeClass(options.starOnClass);
          if (index <= hoveredIndex) {
            $star.addClass(options.starHoverClass);
          }
        });
      }

      function hoverEnd() {
        $.each(stars, function (index, $star) {
          $star.removeClass(options.starHoverClass);
          if (index <= selectedIndex) {
            $star.addClass(options.starOnClass);
          }
        });
      }

      function selectIndex(index) {
        selectedIndex = index;
        $input.val(possibleValues[selectedIndex]);

        $.each(stars, function (index, $star) {
          $star.toggleClass(options.starOnClass, index <= selectedIndex);
        });
      }
    });
  };

  /**
   * Cookie getter and setter
   * @type {{getCookie: $.shopgate.cookie.getCookie, setCookie: $.shopgate.cookie.setCookie}}
   */
  $.shopgate.cookie = {
    /**
     * Reads cookie by given name.
     * @param {string} name
     * @returns {string|null} - null when no cookie was set
     */
    getCookie: function (name) {
      name = name + '=';
      if (window.document.cookie.indexOf(name) === -1) {
        return null;
      }
      var cookieArr = document.cookie.split(';');
      for (var key in cookieArr) {
        var c = cookieArr[key];

        if (c.indexOf(name) === -1) {
          continue;
        }

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return null;
    },
    /**
     * Sets cookie with given name and value.
     * @param {string} name
     * @param {string} value
     * @param {number} expireDays - optional, when negative, cookie will be removed
     */
    setCookie: function (name, value, expireDays) {
      var d = new Date();
      var expiresString = '';
      if (expireDays) {
        d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        expiresString = "expires=" + d.toUTCString();
      } else {
        expiresString = 'expires=Thu, 18 Jan 2038 03:13:59 GMT'; // #year 2038 problem
      }
      console.log(expiresString);

      document.cookie = name + '=' + value + '; ' + expiresString + '; path=/';
    },
  };

  if (typeof UAParser === 'function') {
    /**
     * UAParser default instance.
     */
    $.shopgate.uaparser = new UAParser();
  }

})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-helpers.js